import React, { useEffect, useState } from "react";
import { Container, Form, Row, Col, Button, Table, Modal } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { format } from "date-fns";
import { PencilSquare } from "react-bootstrap-icons";


import { formatDate, formatTime, formatToInputDate, attendanceDateFormat } from "../../../Utils/DateUtlis";
import SideMenu from "../../../Components/SideDrawer";
import PageHeader from "../../../Components/Header";
import { companyGet, employeeAttendanceGetbyCompany, employeeAttendancePut } from "../../../Api/Admin/AdminApi";
import { extractErrorMessage } from "../../../Utils/ErrorUtlis";

const AttendanceView = () => {
  const [apiData, setApiData] = useState([]);
  const [organizations, setOrganizations] = useState([]);
  const [loadingCompany, setLoadingComapany] = useState(true);
  const [isLoading, setIsLoading] = useState(true);
  const [shoModal, setShowModal] = useState(false)
  const [selectedId, setSelectedId] = useState(null);
  const [selectedData, setSelectedData] = useState({
    emp_id: '',
    emp_name: '',
    emp_attendance_date: ''
  });
  const [formData, setFormData] = useState({
    company_id: null,
    att_month: ''
  });
  const [editFormData, setEditFormData] = useState({
    emp_login_time: format(new Date(), "HH:mm:ss"),
    emp_logout_time: format(new Date(), "HH:mm:ss"),
    emp_over_time: null,
    working_meter: null,
    remarks: '',
    project_id: null,
    team_id: null,
    location: ''
  });

  const navigate = useNavigate();

  useEffect(() => {
    const fetchCompany = async () => {
      try {
        const data = await companyGet();
        if (data) {
          const companies = data.map(i => ({
            id: i._id,
            name: i.name,
            description: i.description,
            status: i.status
          }));
          setOrganizations(companies);
          setLoadingComapany(false)
          console.log(`API Data ${JSON.stringify(organizations)}`);  // Under Production         
        } else {
          console.log('No Organization data to fetch');
          alert('No data to Fetch');
        }

      } catch (err) {
        const errorMessage = extractErrorMessage(err)
        console.log('Error Fetching Data in Organization: ', errorMessage || err);
        alert(errorMessage)
      }
    }
    fetchCompany();
  }, []);


  const handleEdit = (editData) => {
    console.log(`Inside handle Edit ${JSON.stringify(editData)}`);
    setShowModal(true);
    setSelectedId(editData.id)
    console.log(`Selected Id: ${selectedId}`);
    setSelectedData({
      emp_id: editData.emp_id,
      emp_name: editData.emp_name,
      emp_attendance_date: attendanceDateFormat(editData.emp_attendance_date)
    });
    console.log(`Date Format: ${selectedData.emp_attendance_date}`);

    setEditFormData({
      emp_login_time: editData.emp_login_time,
      emp_logout_time: editData.emp_logout_time,
      emp_over_time: editData.emp_over_time,
      working_meter: editData.working_meter,
      remarks: editData.remarks,
      project_id: editData.project_id,
      team_id: editData.team_id,
      location: editData.location
    })

  }

  const handleEditClose = () => {
    setShowModal(false);
  }

  const handleEditDateChange = (e) => {
    const { name, value } = e.target;
    const fullDateTime = `${value}:00`

    setEditFormData(prev => ({
      ...prev,
      [name]: fullDateTime
    }));
  }

  const handleEditChange = (e) => {
    const { name, value } = e.target;
    setEditFormData(prev => ({
      ...prev,
      [name]: value
    }));
  }

  const handleEditSubmit = async (e) => {
    e.preventDefault();
    setShowModal(false);
    const loginTime = `${selectedData.emp_attendance_date} ${editFormData.emp_login_time}`
    const logoutTime = `${selectedData.emp_attendance_date} ${editFormData.emp_logout_time}`
    const payload = {
      ...editFormData,
      emp_login_time: loginTime,
      emp_logout_time: logoutTime
    }
    console.log(`Login Time: ${editFormData.emp_login_time}`);
    console.log(`Logout Time: ${editFormData.emp_logout_time}`);
    try {
      const response = await employeeAttendancePut(selectedId, payload);
      if (response) {
        alert('Attendance Updated Successfully...')
      }
    } catch (err) {
      const errorMessage = extractErrorMessage(err)
      console.log('Error Fetching Data in Organization: ', errorMessage || err);
      alert(errorMessage)
    }
  }

  const handleButton = () => {
    navigate('/addAttendance')
  }

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {

    e.preventDefault();
    try {
      setApiData([]);
      setIsLoading(true);
      const responseData = await employeeAttendanceGetbyCompany(formData);
      if (responseData && responseData.results) {
        console.log(`Response Data: ${JSON.stringify(responseData.results)}`);

        const employees = responseData.results.map(i => ({
          id: i._id,
          emp_id: i.emp_id,
          emp_name: i.emp_name,
          Design: i.Design,
          emp_attendance_date: formatDate(i.emp_attendance_date),
          emp_login_time: i.emp_login_time,
          emp_logout_time: i.emp_logout_time,
          emp_over_time: i.emp_over_time,
          working_meter: i.working_meter,
          project_id: i.project_id,
          team_id: i.team_id,
          location: i.location,
          remarks: i.remarks,
          Project: i.Project,
          Team: i.Team
        }));
        console.log('Attendance Date: ', employees);
        setApiData(employees);
        setIsLoading(false);
      } else {
        alert('No Data Received')
      }
    } catch (err) {
      setIsLoading(true);
      const errorMessage = extractErrorMessage(err)
      console.log('Error Fetching Data in Organization: ', errorMessage || err);
      alert(errorMessage)
    }
    console.log(`API data Afeter Submission: ${JSON.stringify(apiData)}`);
    
  }

  return (
    <div>
      <SideMenu />
      <Container fluid style={{
        marginLeft: '250px',
        padding: '20px',
        transition: 'margin 0.3s ease',
        width: 'calc(100% - 250px)'
      }}>
        <PageHeader title='Employee Attendance' showButtons={true} />
        <h4 className="mb-4 d-flex justify-content-between align-items-center">
          Employee Details
          <div className="d-flex flex-column align-items-end">
            <Button variant="primary" className="d-flex align-items-center mb-2" onClick={handleButton}>
              Add Attendance
            </Button>
          </div>
        </h4>
        <Form onSubmit={handleSubmit} className="mt-4 align-items-center">
          <Row className="mb-3">
            <Form.Group as={Col} md="4" controlId="company_id">
              <Form.Label>Organization Name</Form.Label>
              <Form.Select
                name="company_id"
                value={formData.company_id}
                onChange={handleChange}
                required
              >
                <option value="">Select Organization</option>
                {loadingCompany ? (<div>Loading...</div>) : (organizations.map(org => (
                  <option key={org.id} value={org.id}>{org.name}</option>
                )))}
              </Form.Select>
            </Form.Group>
            <Form.Group as={Col} md='4' controlId="att_month">
              <Form.Label>Select Month</Form.Label>
              <Form.Control
                type="month"
                name="att_month"
                value={formData.att_month}
                onChange={handleChange}
                required
                style={{ height: '30px' }}
              >
              </Form.Control>
            </Form.Group>
            <Form.Group as={Col} md='4'>
              <Button type="submit" variant="primary" className="d-flex align-items-center mb-2" style={{ marginTop: '25px',height:'30px'}}>
                Attendance
              </Button>
            </Form.Group>
          </Row>
        </Form>
        {isLoading ? <div className="d-flex justify-content-center align-items-center" style={{ height: '100vh' }}>
          <div role="status">
            <span className="sr-only">No Data to Show</span>
          </div>
        </div> : <div style={{ overflow: 'auto' }}>
          <Table striped hover responsive='sm' size="sm">
            <thead>
              <tr>
                <th className="fs-12">Employee Id</th>
                <th className="fs-12">Employee Name</th>
                <th className="fs-12">Desigination</th>
                <th className="fs-12">Attendance Date</th>
                <th className="fs-12">Login Time</th>
                <th className="fs-12">Logout Time</th>
                <th className="fs-12">Over Time </th>
                <th className="fs-12">Working Meter</th>
                <th className="fs-12">Action</th>
              </tr>
            </thead>
            <tbody>
                {apiData.map((emp, i) => (
                <tr key={emp.emp_id}>
                  <td className="fs-12">
                    {emp.emp_id}
                  </td>
                  <td className="fs-12">
                    {emp.emp_name}
                  </td>
                  <td className="fs-12">
                    {emp.Design}
                  </td>
                  <td className="fs-12">
                    {emp.emp_attendance_date}
                  </td>
                  <td className="fs-12">
                    {emp.emp_login_time}
                  </td>
                  <td className="fs-12">
                    {emp.emp_logout_time}
                  </td>
                  <td className="fs-12">
                    {emp.emp_over_time}
                  </td>
                  <td className="fs-12">
                    {emp.working_meter}
                  </td>
                  <td className="fs-12">
                    <Button variant="outline-primary" size="sm" onClick={() => handleEdit(emp)}>
                      <PencilSquare />
                    </Button>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </div>
        }
        <Modal show={shoModal} onHide={handleEditClose}>
          <Modal.Header closeButton>
            <Modal.Title>
              Attendance Update
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {editFormData && (
              <Form onSubmit={handleEditSubmit}>
                <Form.Group className="md-4" controlId="emp_id">
                  <Form.Label>Employee ID</Form.Label>
                  <Form.Control
                    name="emp_id"
                    value={selectedData.emp_id}
                    disabled
                  ></Form.Control>
                </Form.Group>
                <Form.Group className="md-4" controlId="emp_name">
                  <Form.Label>Employee Name</Form.Label>
                  <Form.Control
                    name="emp_name"
                    value={selectedData.emp_name}
                    disabled
                  ></Form.Control>
                </Form.Group>
                <Row>
<Form.Group className="md-4" controlId="emp_login_time">
                  <Form.Label>Login Time</Form.Label>
                  <Form.Control
                    type="time"
                    name="emp_login_time"
                    value={editFormData.emp_login_time}
                    onChange={handleEditDateChange}
                  ></Form.Control>
                </Form.Group>
                <Form.Group className="md-4" controlId="emp_logout_time">
                  <Form.Label>Logout Time</Form.Label>
                  <Form.Control
                    type="time"
                    name="emp_logout_time"
                    value={editFormData.emp_logout_time}
                    onChange={handleEditDateChange}
                  ></Form.Control>
                </Form.Group>
                </Row>
                <Row>
 <Form.Group as={Col} md="4" controlId="emp_over_time">
                  <Form.Label>Over Time</Form.Label>
                  <Form.Control
                    type="number"
                    name="emp_over_time"
                    value={editFormData.emp_over_time}
                    onChange={handleEditChange}
                    placeholder="Enter Over Time"
                    required
                  />
                </Form.Group>
                <Form.Group as={Col} md="4" controlId="working_meter">
                  <Form.Label>Working Meter</Form.Label>
                  <Form.Control
                    type="number"
                    name="working_meter"
                    value={editFormData.working_meter}
                    onChange={handleEditChange}
                    placeholder="Enter Working Meter"
                    required
                  />
                </Form.Group>
                 <Form.Group as={Col} md="4" controlId="location">
                  <Form.Label>Working Meter</Form.Label>
                  <Form.Control
                    type="text"
                    name="location"
                    value={editFormData.location}
                    onChange={handleEditChange}
                    placeholder="Enter Working Location"
                    required
                  />
                </Form.Group>
                </Row>
                
               
               
                <Row className="mb-4 justify-content-center">
                  <Form.Group as={Col} md='4'>
                    <Button type="submit" variant="primary" className="mt-3">
                      Update
                    </Button>
                  </Form.Group>
                </Row>
              </Form>
            )}
          </Modal.Body>
        </Modal>
      </Container>
    </div>
  );

}

export default AttendanceView;